import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import "../../styles/Navbar.css";
import { Close } from "@mui/icons-material";
import logo from "../../Assets/logo.png";
import { login, try_for_free } from "../../url";

const drawerWidth = "100%";

const NAV_ITEMS = [
  { text: "Home", path: "/2024" },
  { text: "About", path: "/2024/aboutus" },
  { text: "Features", path: "/2024/features" },
  { text: "Security & Compliance", path: "/2024/security" },
  { text: "Pricing Plans", path: "/2024/pricing" },
  { text: "Partners", path: "/2024/patners" },
  { text: "Contact", path: "/2024/contact" },
];

const buttonStyle = {
  color: "#FFFFFF",
  fontFamily: "Roboto",
  height: "45px",
  borderRadius: "10px",
  fontSize: "15px",
  textTransform: "capitalize",
  alignSelf: "center",
  width: "130px",
};

function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setOpen(false); // Close the drawer after navigation
  };

  return (
    <>
      <Box
        sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
      >
        <AppBar
          position="fixed"
          sx={{
            height: "80px",
            display: "flex",
            boxShadow: "0px 2px 4px rgba(22, 98, 167, 0.2)",
            backgroundColor: "white",
          }}
          className="navbar"
        >
          <Toolbar
            sx={{
              maxWidth: "1200px",
              width: "100%",
              mx: "auto",
              px: { xs: 2, sm: 2, md: 3 },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "80px",
            }}
          >
            {/* Logo Section */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <NavLink to="/2024">
                <Box
                  component="img"
                  src={logo}
                  alt="RequireSign Logo"
                  sx={{ width: 170, height: 40 }}
                />
              </NavLink>
            </Box>

            {/* Navigation Links */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  fontSize: "14px",
                  fontWeight: "medium",
                  fontFamily: "Roboto",
                }}
              >
                {NAV_ITEMS.map(({ text, path }, index) => (
                  <React.Fragment key={path || text}>
                    <NavLink
                      to={path}
                      style={({ isActive }) => ({
                        textDecoration: "none",
                        color: isActive ? "#1662A7" : "#6E6B7B",
                        padding: "8px 0",
                        borderBottom: isActive
                          ? "2px solid #1662A7"
                          : "2px solid transparent",
                        transition: "all 0.3s ease",
                      })}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          ":hover": { color: "#1662A7" },
                          fontWeight: "inherit",
                        }}
                      >
                        {text}
                      </Typography>
                    </NavLink>
                    {index < NAV_ITEMS.length - 1 && (
                      <Typography
                        variant="body2"
                        sx={{ color: "#6E6B7B", alignSelf: "center" }}
                      >
                        |
                      </Typography>
                    )}
                  </React.Fragment>
                ))}
              </Stack>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Stack direction="row" spacing={2}>
                <Button
                  component="a"
                  href={try_for_free}
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    backgroundColor: "#25B2E8",
                    ...buttonStyle,
                    "&:hover": {
                      backgroundColor: "#1EA8D9",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Try for FREE
                </Button>
                <Button
                  component="a"
                  href={login}
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    backgroundColor: "#1662A7",
                    ...buttonStyle,
                    "&:hover": {
                      backgroundColor: "#145591",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Login
                </Button>
              </Stack>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      <Box
        sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
      >
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 2px 4px rgba(22, 98, 167, 0.2)",
            height: "70px",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
            }}
          >
            <NavLink to="/2024">
              <Box
                component="img"
                src={logo}
                alt="RequireSign Logo"
                sx={{ width: 140, height: 30 }}
              />
            </NavLink>
            <IconButton onClick={() => setOpen(true)} sx={{ color: "#1662A7" }}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              backgroundColor: "#ffffff",
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          anchor="top"
          open={open}
          onClose={() => setOpen(false)}
        >
          <Box sx={{ px: 3, py: 2 }}>
            {/* Header with Logo and Close */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <NavLink to="/2024" onClick={() => setOpen(false)}>
                <Box
                  component="img"
                  src={logo}
                  alt="RequireSign Logo"
                  sx={{ width: 140, height: 30 }}
                />
              </NavLink>
              <IconButton
                onClick={() => setOpen(false)}
                sx={{ color: "#1662A7" }}
              >
                <Close />
              </IconButton>
            </Box>

            {/* Navigation Links */}
            <Stack spacing={2} sx={{ mb: 4 }}>
              {NAV_ITEMS.map(({ text, path }) => (
                <React.Fragment key={path || text}>
                  <NavLink
                    to={path}
                    style={({ isActive }) => ({
                      textDecoration: "none",
                      padding: "12px 0",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      borderBottom: isActive
                        ? "2px solid #1662A7"
                        : "2px solid transparent",
                      transition: "all 0.3s ease",
                    })}
                    onClick={() => handleNavigation(path)}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "medium",
                        ":hover": { color: "#1662A7" },
                      }}
                    >
                      {text}
                    </Typography>
                  </NavLink>
                </React.Fragment>
              ))}
            </Stack>

            {/* Action Buttons */}
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                component="a"
                href={try_for_free}
                target="_blank"
                rel="noreferrer"
                sx={{
                  backgroundColor: "#25B2E8",
                  ...buttonStyle,
                  "&:hover": {
                    backgroundColor: "#1EA8D9",
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Try for FREE
              </Button>
              <Button
                component="a"
                href={login}
                target="_blank"
                rel="noreferrer"
                sx={{
                  backgroundColor: "#1662A7",
                  ...buttonStyle,
                  "&:hover": {
                    backgroundColor: "#145591",
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Login
              </Button>
            </Stack>
          </Box>
        </Drawer>
      </Box>
    </>
  );
}

export default Navbar;
